import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { MariaDBTableDataset } from 'app/model/dataset/maria-db.dataset';
import { MariaDBLinkedService } from 'app/model/linkedservice/maria-db.linkedservice';
import { extendedColumnTypes } from 'app/shared/utils/column-type.util';
import { format } from 'app/shared/utils/string.util';

export const mariaDBTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(MariaDBTableDataset).name,
    displayName: stringResources.MariaDB_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(MariaDBLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    supportDataTypes: extendedColumnTypes,
    icon: {
        className: 'svg-i-100x100-maria_db'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    showWarningMessage: '{ linkedService && linkedService.driverVersion !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
        stringResources.DriverVersion.toLocaleLowerCase()
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-mariadb',
    category: ['Database'],
    copyJob: {
        multipleQuery: true
    }
};
